import { fmtDate, KIND_LABELS, MODULE_LABELS, ORIGIN_LABELS, STATUS_LABELS } from './ReferralTable';

const Field = ({ label, children }) => (
  <div className="py-2 border-b border-[#F1F5F9]">
    <p className="text-[11px] text-[#94A3B8]">{label}</p>
    <div className="text-[13px] text-[#334155]">{children}</div>
  </div>
);

const ReferralDrawer = ({ row, detail, loading, onClose }) => {
  const who = (user) => (user ? `${user.name || user.username} (@${user.username})` : 'Deleted user');

  return (
    <div className="fixed inset-0 z-50 flex justify-end bg-black/30" onClick={onClose}>
      <div
        className="w-[420px] max-w-full h-full bg-white shadow-xl overflow-y-auto p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-4">
          <p className="text-[15px] font-semibold text-[#0F172A]">Referral detail</p>
          <button onClick={onClose} className="text-[13px] text-[#64748B]">
            Close
          </button>
        </div>

        <Field label="Referrer">{who(row.referrer)}</Field>
        <Field label="Referred">{who(row.referred)}</Field>
        <Field label="Origin">{ORIGIN_LABELS[row.origin] || row.origin}</Field>
        <Field label="Module">
          {MODULE_LABELS[row.module]} · {KIND_LABELS[row.kind] || row.kind}
        </Field>
        <Field label="Status">
          {STATUS_LABELS[row.status]} · {row.progress.count} / {row.progress.threshold}
        </Field>
        <Field label="Started">{fmtDate(row.startedAt)}</Field>
        <Field label="Completed">{fmtDate(row.completedAt)}</Field>

        {loading && <p className="text-[12px] text-[#94A3B8] mt-4">Loading detail…</p>}

        {!loading && detail && (
          <>
            <Field label="Points paid">
              {detail.points?.length
                ? detail.points.map((p) => `${p.role === 'referrer' ? 'Referrer' : 'Referred'}: ${p.amount}`).join(' · ')
                : 'None recorded'}
            </Field>

            {detail.module === 'fancam' && (
              <Field label={`Posts viewed (${detail.viewedPosts?.length || 0})`}>
                <div className="flex flex-wrap gap-2 pt-1">
                  {(detail.viewedPosts || []).map((post) =>
                    post.thumbnailUrl ? (
                      <img
                        key={post.id}
                        src={post.thumbnailUrl}
                        alt=""
                        className="w-14 h-14 rounded object-cover"
                      />
                    ) : (
                      <span key={post.id} className="w-14 h-14 rounded bg-[#E2E8F0]" />
                    )
                  )}
                  {!detail.viewedPosts?.length && 'None yet'}
                </div>
              </Field>
            )}

            {detail.module === 'rateit' && (
              <>
                <Field label={`Moments rated (${detail.items?.length || 0})`}>
                  {detail.items?.length ? detail.items.map((id) => id.slice(-6)).join(', ') : 'None yet'}
                </Field>
                <Field label="Followed the team on activation">
                  {detail.teamFollowedAt ? fmtDate(detail.teamFollowedAt) : 'No'}
                </Field>
                <Field label="Activated from">{detail.source || '—'}</Field>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ReferralDrawer;